import { ADD_DERMATOLOGIST_LIST } from "./action-type";

const initialState = {
    lmbc: {
        list: [],
    },
};

interface Action {
    type: string;
    payload: any;
}

export default (state = initialState, action: Action) => {
    switch (action.type) {
        case ADD_DERMATOLOGIST_LIST: {
            if (!action.payload) {
                return {
                    ...initialState.lmbc.list,
                };
            }
            return {
                ...state,
                lmbc: {
                    list: [...action.payload],
                },
            };
        }
        default:
            return state;
    }
};
